/* Northpix ljusbord — anonym lista i localStorage + delbar länk. Inget kundkonto. */
(function () {
  'use strict';

  var CFG = window.NorthpixFavorites || {};
  var T = CFG.strings || {};
  var KEY = 'northpix-favorites';
  var LIC_KEY = 'northpix-favorites-license';
  var PARAM = 'lista';
  var MAX = 100;
  var base = (CFG.rootUrl || '/').replace(/\/$/, '');

  var ICON_ADD = '<svg class="npx-fav-btn__off" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5.5v13M5.5 12h13"/></svg>';
  var ICON_ADDED = '<svg class="npx-fav-btn__on" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.6l4.6 4.6L19 6.8"/></svg>';
  var ICON_BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><rect x="3" y="7.5" width="18" height="11.5" rx="2"/><circle cx="12" cy="13.2" r="2.1" fill="currentColor" stroke="none"/><path d="M12 3v1.9M7.4 4.3l.95 1.65M16.6 4.3l-.95 1.65"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var ICON_MIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 14l6-6 6 6"/></svg>';
  var GRIP = '<span class="npx-fav-dock__grip" aria-hidden="true"><span></span><span></span><span></span></span>';

  /* ---------- lagring ---------- */
  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    syncBar();
  }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    write(list);
    return i === -1;
  }

  /* Sparar både namnet och platsen i den prisordnade listan. Namnet är översatt
     per språk, platsen är det inte, så den fungerar som reserv vid språkbyte. */
  function readLicRaw() {
    var v = '';
    try { v = localStorage.getItem(LIC_KEY) || ''; } catch (e) { return { t: '', i: -1 }; }
    if (!v) return { t: '', i: -1 };
    if (v.charAt(0) === '{') {
      try {
        var o = JSON.parse(v);
        return { t: o.t || '', i: typeof o.i === 'number' ? o.i : -1 };
      } catch (e) { return { t: '', i: -1 }; }
    }
    return { t: v, i: -1 };
  }
  function readLic() { return readLicRaw().t; }
  function readLicIdx() { return readLicRaw().i; }
  function setLic(t, i) {
    try { localStorage.setItem(LIC_KEY, JSON.stringify({ t: t, i: i })); } catch (e) {}
  }

  /* ---------- produktdata ---------- */
  var cache = {};
  function loadProduct(handle) {
    if (cache[handle]) return cache[handle];
    var stored = null;
    try { stored = JSON.parse(sessionStorage.getItem('npx-fav-p2-' + handle) || 'null'); } catch (e) {}
    if (stored) { cache[handle] = Promise.resolve(stored); return cache[handle]; }
    cache[handle] = fetch(base + '/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var slim = {
          handle: handle, title: p.title, url: p.url,
          image: p.featured_image || (p.images && p.images[0]) || '',
          variants: (p.variants || []).map(function (v) {
            return { id: v.id, title: v.title, price: v.price, available: v.available };
          })
        };
        try { sessionStorage.setItem('npx-fav-p2-' + handle, JSON.stringify(slim)); } catch (e) {}
        return slim;
      })
      .catch(function () { return null; });
    return cache[handle];
  }

  /* /products/x.js returnerar redan en språkprefixad url på /sv.
     Lägg därför bara på base när den saknas, annars blir det /sv/sv/... och 404. */
  function localized(u) {
    if (!u) return '';
    if (!base) return u;
    return (u === base || u.indexOf(base + '/') === 0) ? u : base + u;
  }

  function thumb(url) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2');
  }

  /* Shopifys money-format från temat, med Intl som reserv. */
  function money(cents) {
    if (typeof cents !== 'number') return '';
    var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyWithCurrencyFormat) || '';
    var amount = cents / 100;
    function group(value, decimals, sep, dec) {
      var parts = value.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.length > 1 ? parts.join(dec) : parts[0];
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (m) {
      var value;
      switch (m[1]) {
        case 'amount_no_decimals': value = group(amount, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = group(amount, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = group(amount, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = group(amount, 2, "'", '.'); break;
        case 'amount_with_space_separator': value = group(amount, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = group(amount, 0, ' ', ','); break;
        default: value = group(amount, 2, ',', '.');
      }
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'sv-SE',
        { style: 'currency', currency: 'SEK', maximumFractionDigits: 0 }).format(amount);
    } catch (e) { return String(Math.round(amount)); }
  }

  function postCart(items, btn) {
    if (!items.length) return;
    btn.disabled = true;
    fetch(base + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      window.location.href = base + '/cart';
    }).catch(function () {
      btn.disabled = false;
      toast(T.cartError || '');
    });
  }

  /* ---------- knappar på mediakort ---------- */
  function collectRoots() {
    var roots = [document];
    if (!document.body) return roots;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT, null);
    var n;
    while ((n = walker.nextNode())) { if (n.shadowRoot) roots.push(n.shadowRoot); }
    return roots;
  }

  function handleFromHref(href) {
    if (!href) return '';
    var m = href.match(/\/products\/([^/?#]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function productLinks(el) {
    var out = {};
    var links = el.querySelectorAll ? el.querySelectorAll('a[href*="/products/"]') : [];
    for (var i = 0; i < links.length; i++) {
      var h = handleFromHref(links[i].getAttribute('href'));
      if (h) out[h] = true;
    }
    return Object.keys(out);
  }

  /* Hittar den ruta som faktiskt visar bilden: börjar i länken och går uppåt
     tills elementet innehåller media, är tillräckligt stort och bara rör en produkt. */
  function mediaHost(a) {
    var cand = a;
    for (var i = 0; i < 5 && cand && cand !== document.body; i++) {
      if (cand.querySelector && cand.querySelector('img, video, picture, canvas')) {
        var r = cand.getBoundingClientRect();
        if (r.width >= 80 && r.height >= 60 && productLinks(cand).length <= 1) return cand;
      }
      cand = cand.parentElement;
    }
    return null;
  }

  function makeButton(handle) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'npx-fav-btn';
    btn.setAttribute('data-npx-fav', handle);
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', T.add || 'Save');
    btn.setAttribute('title', T.add || 'Save');
    btn.innerHTML = ICON_ADD + ICON_ADDED;
    return btn;
  }

  function inject() {
    var roots = collectRoots();
    var best = {};
    for (var r = 0; r < roots.length; r++) {
      var links = roots[r].querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < links.length; i++) {
        var a = links[i];
        if (a.closest && a.closest('.npx-fav-dock')) continue;
        var handle = handleFromHref(a.getAttribute('href'));
        if (!handle) continue;
        var host = mediaHost(a);
        if (!host) continue;
        var box = host.getBoundingClientRect();
        var area = box.width * box.height;
        /* Minsta rutan vinner, så knappen hamnar i miniatyren och inte på hela kortet. */
        if (!best[handle] || area < best[handle].area) best[handle] = { host: host, area: area };
      }
    }
    Object.keys(best).forEach(function (handle) {
      var host = best[handle].host;
      if (host.querySelector('.npx-fav-btn')) return;
      if (host.closest && host.closest('[data-npx-fav-host]')) return;
      host.setAttribute('data-npx-fav-host', handle);
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(makeButton(handle));
    });
    syncButtons();
  }

  function syncButtons() {
    var list = read();
    var btns = document.querySelectorAll('.npx-fav-btn');
    for (var i = 0; i < btns.length; i++) {
      var on = list.indexOf(btns[i].getAttribute('data-npx-fav')) !== -1;
      btns[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      btns[i].setAttribute('title', on ? (T.added || 'Saved') : (T.add || 'Save'));
    }
  }

  /* ---------- panel i kanten och flytande knapp ---------- */
  var bar, dock, dockNote, dockList, dockFoot, dockCount, toastEl;
  var state = { handles: [], shared: false, loaded: {} };

  function buildUI() {
    bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'npx-fav-bar';
    bar.setAttribute('data-visible', 'false');
    bar.innerHTML = ICON_BOX + '<span>' + (T.listName || 'List') + '</span><span class="npx-fav-bar__count">0</span>';
    document.body.appendChild(bar);

    dock = document.createElement('aside');
    dock.className = 'npx-fav-dock';
    dock.setAttribute('data-open', 'false');
    dock.setAttribute('aria-label', T.listName || 'List');
    dock.innerHTML =
      '<div class="npx-fav-dock__head">' + GRIP +
        '<span class="npx-fav-dock__title"></span>' +
        '<span class="npx-fav-dock__count"></span>' +
        '<button type="button" class="npx-fav-dock__min" aria-label="' + (T.minimize || 'Minimise') + '" aria-expanded="true">' + ICON_MIN + '</button>' +
        '<button type="button" class="npx-fav-dock__close" aria-label="' + (T.close || 'Close') + '">' + ICON_CLOSE + '</button>' +
      '</div>' +
      '<p class="npx-fav-dock__note" hidden></p>' +
      '<ul class="npx-fav-dock__list"></ul>' +
      '<div class="npx-fav-dock__foot"></div>';
    document.body.appendChild(dock);

    dockNote = dock.querySelector('.npx-fav-dock__note');
    dockList = dock.querySelector('.npx-fav-dock__list');
    dockFoot = dock.querySelector('.npx-fav-dock__foot');
    dockCount = dock.querySelector('.npx-fav-dock__count');

    toastEl = document.createElement('div');
    toastEl.className = 'npx-fav-toast';
    toastEl.setAttribute('data-open', 'false');
    toastEl.setAttribute('role', 'status');
    document.body.appendChild(toastEl);

    bar.addEventListener('click', function () { openDock(read(), false); });
    dock.querySelector('.npx-fav-dock__close').addEventListener('click', closeDock);
    dock.querySelector('.npx-fav-dock__min').addEventListener('click', function () {
      setCollapsed(dock.getAttribute('data-collapsed') !== 'true');
    });
    setupDrag();
    setupResizePersist();
    watchOverlay();
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dock.getAttribute('data-open') === 'true') closeDock();
    });
  }

  /* ---------- flytta, ändra storlek, minimera ---------- */
  var BOX_KEY = 'northpix-favorites-box';

  function isMobile() { return window.matchMedia('(max-width: 600px)').matches; }

  function readBox() {
    try {
      var v = JSON.parse(localStorage.getItem(BOX_KEY) || 'null');
      return (v && typeof v === 'object') ? v : null;
    } catch (e) { return null; }
  }
  function saveBox(patch) {
    var box = readBox() || {};
    Object.keys(patch).forEach(function (k) { box[k] = patch[k]; });
    try { localStorage.setItem(BOX_KEY, JSON.stringify(box)); } catch (e) {}
  }

  /* Håller panelen inom fönstret även efter att skärmen ändrat storlek. */
  function applyBox() {
    if (!dock) return;
    if (isMobile()) {
      dock.style.left = dock.style.top = dock.style.right = dock.style.bottom = '';
      dock.style.width = dock.style.height = '';
      return;
    }
    var box = readBox();
    if (!box) return;
    if (box.w) dock.style.width = Math.min(box.w, window.innerWidth - 24) + 'px';
    if (box.h && dock.getAttribute('data-collapsed') !== 'true') {
      dock.style.height = Math.min(box.h, window.innerHeight - 24) + 'px';
    }
    if (typeof box.left === 'number' && typeof box.top === 'number') {
      var r = dock.getBoundingClientRect();
      var left = Math.min(Math.max(8, box.left), Math.max(8, window.innerWidth - r.width - 8));
      var top = Math.min(Math.max(8, box.top), Math.max(8, window.innerHeight - r.height - 8));
      dock.style.left = left + 'px';
      dock.style.top = top + 'px';
      dock.style.right = 'auto';
      dock.style.bottom = 'auto';
    }
  }

  function setupDrag() {
    var head = dock.querySelector('.npx-fav-dock__head');
    var startX = 0, startY = 0, startLeft = 0, startTop = 0, dragging = false;

    head.addEventListener('pointerdown', function (e) {
      if (isMobile()) return;
      if (e.target.closest('button')) return;
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      var r = dock.getBoundingClientRect();
      startX = e.clientX; startY = e.clientY;
      startLeft = r.left; startTop = r.top;
      dragging = true;
      dock.setAttribute('data-dragging', 'true');
      dock.style.left = startLeft + 'px';
      dock.style.top = startTop + 'px';
      dock.style.right = 'auto';
      dock.style.bottom = 'auto';
      head.setPointerCapture(e.pointerId);
      e.preventDefault();
    });

    head.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var r = dock.getBoundingClientRect();
      var left = Math.min(Math.max(8, startLeft + (e.clientX - startX)), Math.max(8, window.innerWidth - r.width - 8));
      var top = Math.min(Math.max(8, startTop + (e.clientY - startY)), Math.max(8, window.innerHeight - r.height - 8));
      dock.style.left = left + 'px';
      dock.style.top = top + 'px';
    });

    function stop(e) {
      if (!dragging) return;
      dragging = false;
      dock.removeAttribute('data-dragging');
      try { head.releasePointerCapture(e.pointerId); } catch (err) {}
      var r = dock.getBoundingClientRect();
      saveBox({ left: Math.round(r.left), top: Math.round(r.top) });
    }
    head.addEventListener('pointerup', stop);
    head.addEventListener('pointercancel', stop);

    window.addEventListener('resize', applyBox);
  }

  function setupResizePersist() {
    if (typeof ResizeObserver !== 'function') return;
    var t;
    new ResizeObserver(function () {
      if (isMobile()) return;
      if (dock.getAttribute('data-open') !== 'true') return;
      if (dock.getAttribute('data-collapsed') === 'true') return;
      clearTimeout(t);
      t = setTimeout(function () {
        var r = dock.getBoundingClientRect();
        saveBox({ w: Math.round(r.width), h: Math.round(r.height) });
      }, 250);
    }).observe(dock);
  }

  function setCollapsed(on) {
    dock.setAttribute('data-collapsed', on ? 'true' : 'false');
    dock.querySelector('.npx-fav-dock__min').setAttribute('aria-expanded', on ? 'false' : 'true');
    if (!on) applyBox();
  }

  var toastTimer;
  function toast(msg) {
    if (!msg) return;
    toastEl.textContent = msg;
    toastEl.setAttribute('data-open', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.setAttribute('data-open', 'false'); }, 2200);
  }

  /* Temats varukorgslåda och andra overlays ligger ovanpå sidan i nedre kanten.
     Där krockar den flytande knappen med kassaknappen på mobil, så både knappen
     och panelen göms medan något sådant är öppet. */
  function overlayOpen() {
    var o = document.querySelector('.js-overlay');
    if (o) {
      var s = getComputedStyle(o);
      if (s.display !== 'none' && s.visibility !== 'hidden' && parseFloat(s.opacity || '0') > 0.05) return true;
    }
    if (document.body && getComputedStyle(document.body).overflow === 'hidden') return true;
    return false;
  }

  function syncSuppressed() {
    if (!bar) return;
    var hide = overlayOpen();
    if (hide) {
      bar.setAttribute('data-suppressed', 'true');
      dock.setAttribute('data-suppressed', 'true');
    } else {
      bar.removeAttribute('data-suppressed');
      dock.removeAttribute('data-suppressed');
    }
  }

  function watchOverlay() {
    var pending;
    var run = function () { clearTimeout(pending); pending = setTimeout(syncSuppressed, 60); };
    var obs = new MutationObserver(run);
    var o = document.querySelector('.js-overlay');
    if (o) obs.observe(o, { attributes: true, attributeFilter: ['class', 'style'] });
    if (document.body) obs.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    window.addEventListener('pageshow', run);
    syncSuppressed();
  }

  function syncBar() {
    if (!bar) return;
    var n = read().length;
    bar.querySelector('.npx-fav-bar__count').textContent = n;
    var open = dock && dock.getAttribute('data-open') === 'true';
    bar.setAttribute('data-visible', (n > 0 && !open) ? 'true' : 'false');
    syncButtons();
    syncSuppressed();
    if (open && !state.shared) {
      if (!n) { closeDock(); return; }
      renderDock(read(), false);
    }
  }

  function openDock(handles, shared) {
    state = { handles: handles.slice(), shared: !!shared, loaded: state.loaded };
    renderDock(handles, shared);
    dock.setAttribute('data-open', 'true');
    bar.setAttribute('data-visible', 'false');
    applyBox();
    syncSuppressed();
  }

  function closeDock() {
    dock.setAttribute('data-open', 'false');
    state.shared = false;
    syncBar();
  }

  function renderDock(handles, shared) {
    state.handles = handles.slice();
    state.shared = !!shared;

    dock.querySelector('.npx-fav-dock__title').textContent = shared ? (T.sharedTitle || '') : (T.listName || '');
    dockCount.textContent = handles.length ? String(handles.length) : '';
    dockNote.hidden = !shared;
    if (shared) dockNote.textContent = T.sharedNote || '';

    dockList.innerHTML = '';
    if (!handles.length) {
      dockList.innerHTML = '<li class="npx-fav-dock__empty">' + (T.empty || '') + '</li>';
    }

    handles.forEach(function (handle) {
      var li = document.createElement('li');
      li.className = 'npx-fav-row';
      li.innerHTML =
        '<a class="npx-fav-row__thumb" href="' + base + '/products/' + encodeURIComponent(handle) + '"><img alt="" loading="lazy"></a>' +
        '<a class="npx-fav-row__title" href="' + base + '/products/' + encodeURIComponent(handle) + '"></a>' +
        (shared ? '' : '<button type="button" class="npx-fav-row__x" aria-label="' + (T.remove || 'Remove') + '">' + ICON_CLOSE + '</button>');
      dockList.appendChild(li);

      loadProduct(handle).then(function (p) {
        var titleEl = li.querySelector('.npx-fav-row__title');
        if (!p) { titleEl.textContent = handle; return; }
        state.loaded[handle] = p;
        titleEl.textContent = p.title;
        titleEl.setAttribute('href', localized(p.url));
        li.querySelector('.npx-fav-row__thumb').setAttribute('href', localized(p.url));
        var img = li.querySelector('img');
        if (p.image) { img.setAttribute('src', thumb(p.image)); img.setAttribute('alt', p.title); }
      });

      var x = li.querySelector('.npx-fav-row__x');
      if (x) x.addEventListener('click', function () {
        var list = read();
        var i = list.indexOf(handle);
        if (i !== -1) { list.splice(i, 1); write(list); }
      });
    });

    dockFoot.innerHTML = '';
    if (!handles.length) return;

    if (shared) {
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'npx-fav-btn-main';
      add.textContent = T.addShared || 'Add to my list';
      add.addEventListener('click', function () {
        var list = read();
        handles.forEach(function (h) { if (list.indexOf(h) === -1) list.push(h); });
        write(list);
        toast(T.addedShared || '');
        openDock(read(), false);
      });
      dockFoot.appendChild(add);
      return;
    }

    /* Licensvalet gäller hela listan: användningen styr licensen, inte klippet. */
    var licRow = document.createElement('div');
    licRow.className = 'npx-fav-lic';
    dockFoot.appendChild(licRow);

    var cartBtn = document.createElement('button');
    cartBtn.type = 'button';
    cartBtn.className = 'npx-fav-btn-main';
    cartBtn.disabled = true;
    cartBtn.textContent = T.addToCart || 'Add to cart';
    cartBtn.addEventListener('click', function () { postCart(cartItems(), cartBtn); });
    dockFoot.appendChild(cartBtn);

    var share = document.createElement('button');
    share.type = 'button';
    share.className = 'npx-fav-btn-alt';
    share.textContent = T.copyLink || 'Copy link';
    share.addEventListener('click', copyShareLink);
    dockFoot.appendChild(share);

    var dl = document.createElement('button');
    dl.type = 'button';
    dl.className = 'npx-fav-btn-alt';
    dl.textContent = T.downloadAll || 'Download previews';
    dl.addEventListener('click', function () { downloadAll(dl); });
    dockFoot.appendChild(dl);

    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'npx-fav-dock__clear';
    clear.textContent = T.clear || 'Clear';
    clear.addEventListener('click', function () { write([]); });
    dockFoot.appendChild(clear);

    /* Variantnamnet är översatt per språk och kan dessutom vara inaktuellt i
       översättningarna. Matcha därför på namn i första hand, annars på samma
       plats i den prisordnade listan, så att ett byte av språk inte tömmer valet. */
    var licIndex = readLicIdx();

    function variantFor(p) {
      var lic = readLic();
      if (!lic) return null;
      var vs = (p && p.variants) || [];
      for (var i = 0; i < vs.length; i++) {
        if (vs[i].title === lic && vs[i].available !== false) return vs[i];
      }
      if (licIndex >= 0) {
        var sorted = vs.slice().sort(function (a, b) { return a.price - b.price; });
        var v = sorted[licIndex];
        if (v && v.available !== false) return v;
      }
      return null;
    }

    function cartItems() {
      var items = [];
      if (!readLic()) return items;
      state.handles.forEach(function (h) {
        var v = variantFor(state.loaded[h]);
        if (v) items.push({ id: v.id, quantity: 1 });
      });
      return items;
    }

    function refreshCartBtn() {
      var n = cartItems().length;
      cartBtn.disabled = n === 0;
      cartBtn.textContent = (T.addToCart || 'Add to cart') + (n ? ' (' + n + ')' : '');
    }

    Promise.all(handles.map(loadProduct)).then(function (list) {
      if (state.shared) return;
      var seen = {};
      list.forEach(function (p) {
        if (!p || !p.variants) return;
        state.loaded[p.handle] = p;
        p.variants.forEach(function (v) {
          if (!seen[v.title]) seen[v.title] = { title: v.title, prices: {}, min: v.price };
          seen[v.title].prices[v.price] = true;
          if (v.price < seen[v.title].min) seen[v.title].min = v.price;
        });
      });
      var options = Object.keys(seen).map(function (k) { return seen[k]; })
        .sort(function (a, b) { return a.min - b.min; });
      if (!options.length) return;

      if (T.licenseLabel) {
        var label = document.createElement('span');
        label.className = 'npx-fav-lic__label';
        label.textContent = T.licenseLabel;
        licRow.appendChild(label);
      }

      var byName = options.map(function (o) { return o.title; }).indexOf(readLic());
      if (byName >= 0) licIndex = byName;

      options.forEach(function (o, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-pressed', (readLic() === o.title || (byName < 0 && idx === licIndex)) ? 'true' : 'false');
        /* Priset visas bara när alla klipp i listan kostar lika mycket för nivån. */
        var single = Object.keys(o.prices).length === 1;
        b.textContent = o.title + (single && o.min ? ' · ' + money(o.min) : '');
        b.addEventListener('click', function () {
          setLic(o.title, idx);
          licIndex = idx;
          licRow.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          refreshCartBtn();
        });
        licRow.appendChild(b);
      });
      refreshCartBtn();
    });
  }

  /* ---------- provfiler: ladda ner alla ---------- */
  /* Hämtar varje provfil sekventiellt (en i taget — videofiler är stora och
     parallella blobbar äter minne). Fel per objekt räknas och körningen
     fortsätter; resultatet visas som toast och kort i knapptexten. */
  var dlBusy = false;

  function dlFmt(tpl, n, m) {
    return String(tpl || '').replace('%n', n).replace('%m', m);
  }

  function dlExt(blob, url) {
    var type = (blob && blob.type) || '';
    var ext = ((type.split('/')[1] || '').replace('jpeg', 'jpg')).split('+')[0].split(';')[0];
    if (ext === 'quicktime') ext = 'mov';
    if (!ext || ext === 'octet-stream') ext = (url || '').indexOf('.mp4') > -1 ? 'mp4' : 'jpg';
    return ext;
  }

  function dlSave(blob, name) {
    var a = document.createElement('a');
    var objUrl = URL.createObjectURL(blob);
    a.href = objUrl;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(objUrl); }, 5000);
  }

  function downloadAll(btn) {
    if (dlBusy) return;
    var handles = read();
    if (!handles.length) return;
    dlBusy = true;
    btn.disabled = true;
    var total = handles.length;
    var ok = 0, fail = 0, i = 0;

    function step() {
      if (i >= total) { finish(); return; }
      var handle = handles[i];
      i++;
      btn.textContent = dlFmt(T.downloadAllBusy || '%n / %m', i, total);
      fetch(base + '/products/' + encodeURIComponent(handle) + '?view=npx-preview')
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (d) {
          if (!d || !d.u) throw new Error('no url');
          return fetch(d.u)
            .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.blob(); })
            .then(function (blob) {
              dlSave(blob, 'northpix-provfil-' + handle + '.' + dlExt(blob, d.u));
              ok++;
            });
        })
        .catch(function () { fail++; })
        .then(step);
    }

    function finish() {
      dlBusy = false;
      var msg = fail
        ? dlFmt(T.downloadAllError || '', fail, total)
        : dlFmt(T.downloadAllDone || '', ok, total);
      toast(msg);
      btn.textContent = msg;
      setTimeout(function () {
        btn.textContent = T.downloadAll || '';
        btn.disabled = false;
      }, 3000);
    }

    step();
  }

  /* ---------- delning ---------- */
  function shareUrl() {
    return window.location.origin + (base || '') + '/?' + PARAM + '=' + read().map(encodeURIComponent).join(',');
  }
  function copyShareLink() {
    var url = shareUrl();
    var done = function () { toast(T.copied || ''); };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(done, function () { fallbackCopy(url, done); });
    } else {
      fallbackCopy(url, done);
    }
  }
  function fallbackCopy(text, done) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); done(); } catch (e) { window.prompt(T.copyManual || '', text); }
    document.body.removeChild(ta);
  }
  function readShared() {
    var m = window.location.search.match(new RegExp('[?&]' + PARAM + '=([^&]*)'));
    if (!m || !m[1]) return null;
    return m[1].split(',').map(function (h) {
      try { return decodeURIComponent(h); } catch (e) { return h; }
    }).filter(Boolean).slice(0, MAX);
  }

  /* ---------- init ---------- */
  function init() {
    buildUI();
    inject();
    syncBar();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.npx-fav-btn') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-npx-fav');
      var added = toggle(handle);
      toast(added ? (T.toastAdded || '') : (T.toastRemoved || ''));
    }, true);

    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var b = e.target.closest ? e.target.closest('.npx-fav-btn') : null;
        if (b) { e.stopPropagation(); }
      }, true);
    });

    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(inject, 120);
    }).observe(document.body, { childList: true, subtree: true });

    window.addEventListener('storage', function (e) { if (e.key === KEY) syncBar(); });

    var shared = readShared();
    if (shared && shared.length) openDock(shared, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
